import { ILanguageConfigCash, ILanguageConfigCurrency } from '../../interfaces/ILanguageConfig';

const currency: ILanguageConfigCurrency = {
  long: 'euro',
  short: '€',
  code: 'EUR',
  mainUnit: {
    long: 'euro',
    short: '€',
  },
  subUnit: {
    long: 'cent',
    short: '€'
  }
};

const banknotes: ILanguageConfigCash[] = [
  {
    value: 500,
    displayValue: '500',
    unit: currency.mainUnit
  },
  {
    value: 200,
    displayValue: '200',
    unit: currency.mainUnit
  },
  {
    value: 100,
    displayValue: '100',
    unit: currency.mainUnit
  },
  {
    value: 50,
    displayValue: '50',
    unit: currency.mainUnit
  },
  {
    value: 20,
    displayValue: '20',
    unit: currency.mainUnit
  },
  {
    value: 10,
    displayValue: '10',
    unit: currency.mainUnit
  }
];

const coins: ILanguageConfigCash[] = [
  {
    value: 5,
    displayValue: '5',
    unit: currency.mainUnit
  },
  {
    value: 2,
    displayValue: '2',
    unit: currency.mainUnit
  },
  {
    value: 1,
    displayValue: '1',
    unit: currency.mainUnit
  },
  {
    value: 50,
    displayValue: '0.50',
    unit: currency.subUnit
  },
  {
    value: 20,
    displayValue: '0.20',
    unit: currency.subUnit
  },
  {
    value: 10,
    displayValue: '0.10',
    unit: currency.subUnit
  },
  {
    value: 5,
    displayValue: '0.05',
    unit: currency.subUnit
  },
  {
    value: 2,
    displayValue: '0.02',
    unit: currency.subUnit
  },
  {
    value: 1,
    displayValue: '0.01',
    unit: currency.subUnit
  }
];

export default {
  currency,
  banknotes,
  coins
};
